/**
 * Documents API Service
 */

import apiClient from './client';
import type { Document, UploadDocumentDto } from './types';

export const documentsApi = {
  /**
   * Récupérer tous les documents de l'utilisateur
   */
  async getAll(): Promise<Document[]> {
    const response = await apiClient.get<Document[]>('/documents');
    return response.data;
  },

  /**
   * Récupérer un document par ID
   */
  async getById(id: string): Promise<Document> {
    const response = await apiClient.get<Document>(`/documents/${id}`);
    return response.data;
  },

  /**
   * Upload un document
   */
  async upload(formData: FormData): Promise<Document> {
    const response = await apiClient.post<Document>('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * Générer une URL de téléchargement signée
   */
  async getDownloadUrl(id: string): Promise<{ url: string }> {
    const response = await apiClient.get<{ url: string }>(`/documents/${id}/download`);
    return response.data;
  },

  /**
   * Supprimer un document
   */
  async delete(id: string): Promise<void> {
    await apiClient.delete(`/documents/${id}`);
  },
};
